import { User, userQueryKey, useQueryClient } from '@alluradirect/react';
import { SignupCreateAccount } from 'components/views/pages/signup/SignupCreateAccount';

interface Props {
  initialEmail: string;
  close: () => void;
}

export const CheckoutCreateAccountForm = ({ initialEmail, close }: Props) => {
  const qClient = useQueryClient();

  const onSuccess = async (_data: User) => {
    await qClient.resetQueries({ queryKey: [userQueryKey] });
    await qClient.resetQueries({ queryKey: ['checkout'] });
    await qClient.resetQueries({ queryKey: ['GUEST_BOOKING'] });
    close();
  };

  return (
    <SignupCreateAccount
      hasTopAppDivider={false}
      navigateOnSuccess={onSuccess}
      hasFooter={false}
      initialEmail={initialEmail}
      isEmailFieldDisabled={true}
    />
  );
};
